import {konsole, $, iFrameResize} from '../util';
import IframeBrowser from '../modules/IframeBrowser';
import {dealerIDs} from '../setup';
import cookieStatus from '../cookieStatus';

const devenv = (
  window.location.hostname.indexOf("minimostdev") > -1 ||
  window.location.hostname.indexOf("local") > -1 ||
  window.location.hostname.indexOf("wwwdev.minimost") > -1
);

class FormApiEmbedded {
  constructor(id, setup, __CarSearch) {
    let env = "prod";
    this.id = id;
    this.setup = $.extend({}, setup || {});
    this.protocol = window.location.protocol;
    this.envHosts = {
      dev: "testapi.bmwgrouphosting.hu",
      test: "testapi.bmwgrouphosting.hu",
      local: "bmwapi.local",
      prod: "miniapi.minimost.hu"
    };
    this.trackingFeasible = true;
    const saveOn = window.location.search.indexOf("saveon=0") > -1;
    if (devenv) {
      env = saveOn ? "dev" : "test";
      this.trackingFeasible = false;
    }

    this.domain = this.envHosts[env];
    this.params = "?ci=mini&rt=rfo&mt=minimost";
    if (env === "dev") {
      this.params += "&save=0";
    }
    this.url = this.protocol + "//" + this.domain + "/" + this.params;

    this.callback = null;
    this.__CarSearch = __CarSearch;
    this.iFrameResizerActive = false;
    this.iframeBrowser = new IframeBrowser(
      {
        id,
        onLoad: () => {
          if (typeof this.callback === "function") {
            this.callback();
          }
          this.resize();
        }
      },
      null,
      false
    );
    this.currentData = null;
  }

  setData(data) {
    this.currentData = data || null;
    let dealerParam = "";
    let leadCtxParam = "";
    let leadTlParam = "";
    if (data.dealerProps.length === 1) {
      if (dealerIDs[data.dealerProps[0]]) {
        dealerParam = "&dlrid=" + dealerIDs[data.dealerProps[0]];
      }
      else {
        konsole.log("// WARNING: invalid value: " + data.dealerProps[0]);
      }
    }

    if (typeof data.callback === "function") {
      this.callback = data.callback;
    }

    // console.log('SETUP CTX', this.setup.leadctx);
    // console.log('SETUP CTXID', this.setup.leadctxid);
    // console.log('SETUP TL', this.setup.leadtl);
    // console.log('DATA WHITELIST', data.ctx_whitelist);


    if (
      this.setup.leadctx && data.ctx_whitelist && (
        this.setup.leadctx ||
        data.ctx_whitelist.indexOf(this.setup.leadctxid) > -1 // prop name of this.setup.leadctx
      )
    ) {
      leadCtxParam = "&leadctx=" + this.setup.leadctx;
    }
    else if (this.setup.saleDefaultLeadCtxId) {
      leadCtxParam = "&leadctx=" + this.setup.saleDefaultLeadCtxId;
    }

    if (this.setup.leadtl) {
      leadTlParam = "&tl=" + this.setup.leadtl;
    }

    const url = (
      this.url +
      dealerParam +
      leadCtxParam +
      leadTlParam +
      "&model=" +
      data.id +
      "&dealers=" +
      data.dealerProps.join(",") +
      "&interest=" +
      data.seriesCode +
      "&cookies=" + (
        this.trackingFeasible ? cookieStatus() : '0'
      )
    );
    this.iframeBrowser.setUrl(url);

    return this;
  };

  resize() {};

  detach() {
    this.iframeBrowser.detach();
    return this;
  };

  attach($to) {
    this.iframeBrowser.attach($to);

    if (!this.iFrameResizerActive && typeof iFrameResize === "function") {
      iFrameResize(
        {
          inPageLinks: false
        },
        this.iframeBrowser.iframe
      );
      this.iFrameResizerActive = true;
    }
    return this;
  };

}


export default FormApiEmbedded;
